import { TransactionFilterInterface } from 'modules/payment/transactions/types/transaction-filter-interface'
import { TransactionInterface } from 'modules/payment/transactions/types/transaction-interface'
import { ExportOptionsInterface } from 'shared/components/csv-export-modal'

export enum ExportTransactionsCsvColumnsEnum {
  CustomerEmail = 'customer_email',
  TransactionDate = 'transaction_date',
  Amount = 'amount',
  ProductName = 'product_name',
  Vat = 'vat',
  CustomerAddress = 'customer_address',
  CustomerName = 'customer_name',
  InvoiceNumber = 'invoice_number',
  Coupon = 'coupon',
  Shipping = 'shipping',
}

export const exportTransactionsCsvLocoKeys: Record<ExportTransactionsCsvColumnsEnum, string> = {
  [ExportTransactionsCsvColumnsEnum.CustomerEmail]: 'dashboard.transactions.csv.email',
  [ExportTransactionsCsvColumnsEnum.TransactionDate]: 'dashboard.transactions.csv.transaction_date',
  [ExportTransactionsCsvColumnsEnum.Amount]: 'dashboard.transactions.csv.amount',
  [ExportTransactionsCsvColumnsEnum.ProductName]: 'dashboard.transactions.csv.product_name',
  [ExportTransactionsCsvColumnsEnum.Vat]: 'dashboard.transactions.csv.vat',
  [ExportTransactionsCsvColumnsEnum.CustomerAddress]: 'dashboard.transactions.csv.customer_address',
  [ExportTransactionsCsvColumnsEnum.CustomerName]: 'dashboard.transactions.csv.customer_name',
  [ExportTransactionsCsvColumnsEnum.InvoiceNumber]: 'dashboard.transactions.csv.invoice_number',
  [ExportTransactionsCsvColumnsEnum.Coupon]: 'dashboard.transactions.csv.coupon',
  [ExportTransactionsCsvColumnsEnum.Shipping]: 'dashboard.transactions.csv.shipping',
}

export interface ExportTransactionsDataInterface {
  allChecked: boolean
  transactionIds: TransactionInterface['id'][]
  filter: TransactionFilterInterface
}

export interface ExportTransactionsCsvDataInterface extends ExportTransactionsDataInterface {
  exportOptions: ExportOptionsInterface<ExportTransactionsCsvColumnsEnum>
}
